import ProfileRouter from "./router/profile-router";

export default [ProfileRouter];
